import { Drawer } from "antd";
import React from "react";
import { connect } from "react-redux";
import { Card, notification, Tooltip, Button, Checkbox } from 'antd'
import { TableComp } from "sz-react-utils";
import moment from "moment";
import Request, { MEDIA_URL } from "../../request";
import WithdrawStudentRequestFinalStage from "./WithdrawStudentRequestFinalStage";
import _ from 'lodash';

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

let userCheckBox = {};
let usersData = {};

class WithdrawRequestListDrawer extends React.Component {
    state = {
        visible: true,
        recordId: null,
        showWithdrawForm: false,
        total: 0,
        formAction: '',
        enableBTN: false,
        userCheckBox: {},
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        }, 50);
    };


    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let data = await Request.getInvoiceWithdrawRequests({
                ...params,
                regExFilters: [
                    'studentName'
                ]
            });

            _.each(data.data, (request) => {
                if (!userCheckBox[request._id]) {
                    userCheckBox[request._id] = { ...request, checked: false }
                }
            });

            this.setState({ total: data.total, userCheckBox })
            resolve(data)
        })
    }

    updateBulkStatus = () => {
        let userArr = _.filter(this.state.userCheckBox, (item) => {
            return item.checked;
        });
        if (userArr && userArr.length) {
            usersData = userArr;
            this.setState({ showWithdrawForm: true });
        } else {
            notification.error({
                message: "Please select atleast 1 user.",
            });
        }
    };


    selectUser = (item, studentId) => {
        let cloneUserCheckBox = _.clone(this.state.userCheckBox);
        cloneUserCheckBox[studentId].checked = !cloneUserCheckBox[studentId]
            .checked;
        this.setState({ userCheckBox: cloneUserCheckBox });
    };


    closeWithdrawFrom = () => {
        this.setState({ showWithdrawForm: false, recordId: null }, () => {
            this.table.current.reload();
        });
    }

    withdrawStudent = async (data) => {
        if (!data.withdrawFinanceNote) {
            return notification.error({
                message: 'Please enter withdraw reason.'
            })
        }
        let invoiceGenerationRecord = this.printInvoiceDate(data.recordId.nextInvoiceGenerationDates);
        data.invoiceGeneratedRecordId = invoiceGenerationRecord._id
        data.recordId = data.recordId._id;
        let response = await Request.withdrawStudentFinanceUpdate(data);
        if (!response.error) {
            if (this.table && this.table.current) {
                this.table.current.reload();
            }
            this.setState({ showWithdrawForm: false })
            notification.success({ message: response.msg });
        } else {
            notification.error({
                message: response.message
            })
        }
    }


    printInvoiceDate = (nextInvoiceGenerationDates) => {
        if (nextInvoiceGenerationDates.length) {
            let generatedInvoices = nextInvoiceGenerationDates.filter(item => (item.withdrawRequest === true && item.withdrawRequstStatus === 'Pending'));
            return generatedInvoices.length > 0 ? generatedInvoices[0] : null;
        }
    }
    render() {
        let { total, visible, showWithdrawForm, recordId, formAction, enableBTN, userCheckBox } = this.state

        const columns = [
            {
                title: 'Action',
                key: 'checkboxMultiple',
                dataindex: 'checkboxMultiple',
                width: 80,
                render: (text, record) => (
                    <React.Fragment>
                        <div>
                            <div >
                                <Tooltip title="Perform action on Withdraw request">
                                    &nbsp;&nbsp;&nbsp;<Button
                                        loading={false}
                                        onClick={() => { this.setState({ recordId: record, showWithdrawForm: true }) }}
                                        shape="circle"
                                        icon="check"
                                    />
                                </Tooltip>
                                <Checkbox
                                    style={{ marginLeft: 10 }}
                                    checked={
                                        userCheckBox[record._id]
                                            ? userCheckBox[record._id].checked
                                            : false
                                    }
                                    onChange={(y) => {
                                        this.selectUser(y, record._id);
                                    }}
                                />

                            </div>
                        </div>
                    </React.Fragment>
                )
            },
            {
                title: 'VID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 80,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Details',
                key: 'studentDetails',
                dataIndex: 'studentName',
                sorter: true,
                width: 200,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (text, record) => (
                    <div >
                        <React.Fragment>
                            <div>
                                <Tooltip title="Click To Edit Details">
                                    <a target={'_blank'}
                                        href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                    >{text}</a>
                                </Tooltip>
                                <div><b>Mobile:-</b> {record.mobile}</div>
                                <div><b>Email:-</b> {record.emailId}</div>
                                <div><b>Student ID:-</b> {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.instituteStudentId : 'NA'}</div>
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'University Details',
                key: 'universityDetails',
                width: 200, // Increased width for better readability
                searchTextName: 'universityDetails',
                render: (text, record) => {
                    let visaDesk = record && record.visaDesk ? record.visaDesk : null;
                    let selectedCourse = visaDesk && visaDesk.selectedCourse ? visaDesk.selectedCourse : null;

                    // Determine Partner Display
                    let isPartner = selectedCourse && selectedCourse.channelPartnerName && selectedCourse.channelPartnerId;
                    let partnerName = isPartner ? selectedCourse.channelPartnerName : 'Direct';

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {/* University Name - Primary Detail */}
                            <div style={{ fontWeight: 600, color: '#262626', lineHeight: '1.2' }}>
                                {selectedCourse && selectedCourse.universityInstitutionName ? selectedCourse.universityInstitutionName : 'N/A'}
                            </div>

                            {/* Partnership Status - Secondary Detail */}
                            <div>
                                {isPartner ? (
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#1890ff',
                                        background: '#e6f7ff',
                                        padding: '1px 6px',
                                        borderRadius: '4px',
                                        border: '1px solid #91d5ff',
                                        display: 'inline-block'
                                    }}>
                                        {partnerName}
                                    </span>
                                ) : (
                                    <span style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                        {partnerName}
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Term / Invoice Generation Date',
                key: 'invoiceGenerationDates',
                dataIndex: 'nextInvoiceGenerationDates',
                searchTextName: `Search Term`,
                width: 100,
                render: (text, record) => {

                    const invoice = this.printInvoiceDate(record.nextInvoiceGenerationDates);

                    return (
                        <div>
                            {invoice ? (
                                <div>
                                    <b>{"T" + (invoice.invoiceNo || "")}</b>{"/"}
                                    {moment(invoice.generationDate).format(dateFormat)}
                                </div>
                            ) : null}
                        </div>
                    );
                }
            },
            {
                title: 'Withdrawal Reason',
                key: 'withdrawReason',
                dataIndex: 'withdrawReason',
                searchTextName: 'Withdrawal Reason',
                width: 100,
                render: (text, record) => (
                    <div >
                        <React.Fragment>
                            <div>
                                {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawReason : null}
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Withdrawal Request Submission Date',
                key: 'withdrawDate',
                dataIndex: 'withdrawDate',
                searchTextName: `Withdraw Request Date ${dateFormat}`,
                width: 100,
                render: (text, record) => (
                    <div >
                        <React.Fragment>
                            <div>
                                {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? moment(this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawReasonDate).local().format(dateFormat) : null}
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Withdrawal Proof',
                key: 'mailFromUniversity',
                dataIndex: 'mailFromUniversity',
                width: 100,
                render: (text, record) => (
                    <div >
                        <React.Fragment>
                            <div>
                                {
                                    this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity.length &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url ?
                                        <div><b>Mail From Univerisity:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url} target="_blank" rel='noopener noreferrer'>View</a></div>
                                        : null
                                }
                                {
                                    this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent.length &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url ?
                                        <div><br /><b>Mail From Student:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url} target="_blank" rel='noopener noreferrer'>View</a></div>
                                        : null
                                }
                                {
                                    this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument.length &&
                                        this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url ?
                                        <div><br /><b>Other Document:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url} target="_blank" rel='noopener noreferrer'>View</a></div>
                                        : null
                                }
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Stage',
                key: 'withdrawFinalStageNote',
                dataIndex: 'withdrawFinalStageNote',
                width: 100,
                render: (text, record) => (
                    <div>
                        <React.Fragment>
                            <div>
                                <b>Note:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawFinalStageNote : null}
                                <br />
                                <b>Status:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawRequstStatus : null}
                            </div>
                        </React.Fragment>
                    </div>
                )
            }
        ]
        return (
            <>
                {
                    showWithdrawForm ?
                        <WithdrawStudentRequestFinalStage onClose={this.closeWithdrawFrom} onSelect={(e) => this.withdrawStudent(e)} formAction={formAction} recordId={recordId} records={usersData} enableBTN={enableBTN} />
                        : null
                }
                <Drawer
                    title={`Withdraw Requests:${total}`}
                    placement="right"
                    closable={true}
                    onClose={this.onClose}
                    visible={visible}
                    width={1200}
                >
                    <Card bordered={true} style={{ marginTop: 10 }}>
                        <Button type="primary" onClick={this.updateBulkStatus}>Update Status</Button>
                    </Card>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}


                    />
                </Drawer>

            </>

        )
    }
}


const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithdrawRequestListDrawer)